import { Id } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getProjectLogs(httpClient: HttpClient) {
  return (projectId: Id) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/comments/${projectId}/logs`,
      method: HttpMethods.GET,
    });
}

export { getProjectLogs };
